import { Checkbox } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { GroupSessionsAgeRestrictionEnabledFieldFormBeanPart } from './GroupSessionsAgeRestrictionEnabledField.types';

export type VideoConsultationValue = boolean;

type GroupSessionsAgeRestrictionEnabledFieldProps = Pick<
   FormContextValues<GroupSessionsAgeRestrictionEnabledFieldFormBeanPart>,
   'register'
>;

export const GroupSessionsAgeRestrictionEnabledField = (
   props: GroupSessionsAgeRestrictionEnabledFieldProps
): JSX.Element => {
   return (
      <Checkbox
         testId={'ageRestrictionEnabled'}
         label={translationKeys.ageRestrictionEnabled}
         controller={props.register('ageRestrictionEnabled')}
         defaultValue={false}
      />
   );
};
